import createIcon from '../../createIcon';

/**
 * @component @name SportsCricket
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMDQxNSAxMi43OUw2LjU0MTUyIDQuMjlDNi4zNTE1MiA0LjEgNi4wOTE1MiA0IDUuODMxNTIgNEM1LjU3MTUyIDQgNS4zMjE1MiA0LjEgNS4xMzE1MiA0LjI5TDIuMjkxNTIgNy4xM0MxLjkwMTUyIDcuNTIgMS45MDE1MiA4LjE2IDIuMjkxNTIgOC41NUwxMC43OTE1IDE3LjA1QzEwLjk5MTUgMTcuMjUgMTEuMjQxNSAxNy4zNCAxMS41MDE1IDE3LjM0QzExLjc2MTUgMTcuMzQgMTIuMDExNSAxNy4yNCAxMi4yMTE1IDE3LjA1TDE1LjA0MTUgMTQuMjJDMTUuNDMxNSAxMy44MiAxNS40MzE1IDEzLjE4IDE1LjA0MTUgMTIuNzlaTTExLjUwMTUgMTQuOTJMNC40MTE1MiA3LjgzTDUuODMxNTIgNi40MUwxMi45MjE1IDEzLjVMMTEuNTAxNSAxNC45MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNS43NTY5IDE2LjM0MkwxNC4zNDI3IDE3Ljc1NjJMMTguNTg1MyAyMS45OTg4TDE5Ljk5OTUgMjAuNTg0NkwxNS43NTY5IDE2LjM0MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC41MDE1IDJDMTYuNTcxNSAyIDE1LjAwMTUgMy41NyAxNS4wMDE1IDUuNUMxNS4wMDE1IDcuNDMgMTYuNTcxNSA5IDE4LjUwMTUgOUMyMC40MzE1IDkgMjIuMDAxNSA3LjQzIDIyLjAwMTUgNS41QzIyLjAwMTUgMy41NyAyMC40MzE1IDIgMTguNTAxNSAyWk0xOC41MDE1IDdDMTcuNjcxNSA3IDE3LjAwMTUgNi4zMyAxNy4wMDE1IDUuNUMxNy4wMDE1IDQuNjcgMTcuNjcxNSA0IDE4LjUwMTUgNEMxOS4zMzE1IDQgMjAuMDAxNSA0LjY3IDIwLjAwMTUgNS41QzIwLjAwMTUgNi4zMyAxOS4zMzE1IDcgMTguNTAxNSA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsCricket = createIcon('SportsCricket', [
  [
    'path',
    {
      d: 'M15.0415 12.79L6.54152 4.29C6.35152 4.1 6.09152 4 5.83152 4C5.57152 4 5.32152 4.1 5.13152 4.29L2.29152 7.13C1.90152 7.52 1.90152 8.16 2.29152 8.55L10.7915 17.05C10.9915 17.25 11.2415 17.34 11.5015 17.34C11.7615 17.34 12.0115 17.24 12.2115 17.05L15.0415 14.22C15.4315 13.82 15.4315 13.18 15.0415 12.79ZM11.5015 14.92L4.41152 7.83L5.83152 6.41L12.9215 13.5L11.5015 14.92Z',
      key: 'opi6p7',
    },
  ],
  [
    'path',
    {
      d: 'M15.7569 16.342L14.3427 17.7562L18.5853 21.9988L19.9995 20.5846L15.7569 16.342Z',
      key: '127idv',
    },
  ],
  [
    'path',
    {
      d: 'M18.5015 2C16.5715 2 15.0015 3.57 15.0015 5.5C15.0015 7.43 16.5715 9 18.5015 9C20.4315 9 22.0015 7.43 22.0015 5.5C22.0015 3.57 20.4315 2 18.5015 2ZM18.5015 7C17.6715 7 17.0015 6.33 17.0015 5.5C17.0015 4.67 17.6715 4 18.5015 4C19.3315 4 20.0015 4.67 20.0015 5.5C20.0015 6.33 19.3315 7 18.5015 7Z',
      key: '1a0g0r',
    },
  ],
]);

export default SportsCricket;
